import React from "react";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";

export const CTA = () => {
  const { t } = useLanguage();

  return (
    <section
      id="cta"
      data-testid="cta-section"
      className="relative py-24 md:py-32 border-t border-slate-800 overflow-hidden"
    >
      {/* Deep blue gradient background */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at 50% 0%, rgba(37,99,235,0.35), transparent 55%), linear-gradient(180deg, #0B1221 0%, #050912 100%)",
        }}
        aria-hidden="true"
      />
      <div
        className="absolute inset-0 opacity-[0.08]"
        style={{
          backgroundImage:
            "linear-gradient(to right, #93c5fd 1px, transparent 1px), linear-gradient(to bottom, #93c5fd 1px, transparent 1px)",
          backgroundSize: "56px 56px",
        }}
        aria-hidden="true"
      />

      <div className="relative max-w-5xl mx-auto px-6 md:px-12 text-center">
        <p
          className="text-[11px] tracking-[0.25em] uppercase text-blue-300 mb-6"
          style={{ fontFamily: "'IBM Plex Mono', monospace" }}
        >
          {t.cta.overline}
        </p>
        <h2
          className="text-3xl md:text-5xl lg:text-6xl font-bold tracking-tight text-slate-50 leading-[1.05] max-w-3xl mx-auto"
          style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
          data-testid="cta-title"
        >
          {t.cta.title}
        </h2>
        <p
          className="mt-6 text-base md:text-lg text-slate-300 max-w-2xl mx-auto"
          style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}
        >
          {t.cta.subtitle}
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="mailto:support@bluebrotherstech.com"
            data-testid="cta-primary-button"
            className="group inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-slate-50 hover:bg-white text-slate-950 rounded-sm font-medium transition-all duration-300 shadow-[0_0_50px_rgba(255,255,255,0.15)]"
            style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}
          >
            {t.cta.primary}
            <ArrowUpRight size={18} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
          <a
            href="mailto:support@bluebrotherstech.com"
            data-testid="cta-email-link"
            className="text-sm md:text-base text-blue-300 hover:text-blue-200 underline-offset-4 hover:underline transition-colors"
            style={{ fontFamily: "'IBM Plex Mono', monospace" }}
          >
            {t.cta.secondary}
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTA;
